const newAnetapackFrom = (fromEmail: string): string => `<!DOCTYPE html
PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
<title>You've started your Aneta membership!</title>
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<style>
  @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@500;600&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Proxima+Nova');
  body {
    width: 100% !important;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    margin: 0;
    padding: 0;
    line-height: 100%;
  }

  [style*="proxima-nova"] {font-family: 'proxima-nova', sans-serif !important;}

  img {
    outline: none;
    text-decoration: none;
    border:none;
    -ms-interpolation-mode: bicubic;
    max-width: 100%!important;
    margin: 0;
    padding: 0;
    display: block;
  }
  
  table td {
    border-collapse: collapse;
  }
  
  table {
    border-collapse: collapse;
    mso-table-lspace: 0pt;
    mso-table-rspace: 0pt;
  }
</style>
</head>

<body style="margin: 0; padding: 0;">
<table cellpadding="0" cellspacing="0" height="848" width="600" bgcolor="#ffffff" align="center" >
  <tr>
    <td style="border-radius: 30px;">
      <table>
        <tr>
          <td height="116" width="114" style="padding-right: 24px; padding-left: 50px;"><img align="center" alt="logo" src="https://i.ibb.co/xY9scG6/Asset-1-1500x-2.png"></td>
          <td height="80" width="302">
            <img align="center" alt="logo" src="https://i.ibb.co/QvLX3kq/image-1.png" style="margin-bottom: 6px;">
            <table>
              <tr>
                <td style="color: #8B8B92; font-size: 14px; font-weight: normal; font-family: 'proxima-nova', sans-serif;"">Give Independence. Take back your Day.</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <table>
        <tr>
          <td style="padding: 60px 80px 0 80px;">
            <table cellpadding="0" cellspacing="0" style="margin-bottom: 5px;">
              <tr style="color: #1B0C3D; font-size: 17px; font-weight: bold; font-family: 'proxima-nova', sans-serif;">
                <td>Hello!</td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0">
              <tr style="color: #1B0C3D; font-size: 17px; font-weight: bold; font-family: 'proxima-nova', sans-serif;">
                <td>You have a new Anetapack from <span style="color: #00B5BA;">${fromEmail}</span> !</td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" style="margin-top: 35px;">
              <tr style="color: #8D869E; font-size: 14px; font-weight: 300; font-family: 'proxima-nova', sans-serif; line-height: 150%;">
                <td><a href="https://app.anetaed.com/choose-role" target="_blank" rel="noreferrer"  style="text-decoration: none; color: #00B5BA;">Aneta</a> helps parents and children find their way through digital education and edutainment resources.</td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" style="margin-top: 16px;">
              <tr style="color: #8D869E; font-size: 14px; font-weight: 300; font-family: 'proxima-nova', sans-serif; line-height: 150%;">
                <td>An Anetapack contains a curated schedule of  activities and digital resources. It makes setup for your scholar on Aneta super easy with the sweet bonus of introducing you to helpful digital resources.</td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" style="margin-top: 60px;" width="100%">
              <tr style="color: #5F5577; font-size: 14px; font-weight: normal; font-family: 'proxima-nova', sans-serif; line-height: 150%;">
                <td>
                  <table cellpadding="0" cellspacing="0" width="140" align="left">
                    <tr>
                      <td align="center" style="padding-left: 20px;">
                        Already have </br> an Aneta Account?
                      </td>
                    </tr>
                  </table>
                </td>
                <td>
                  <table  cellpadding="0" cellspacing="0" width="140" align="right">
                    <tr>
                      <td align="center" style="padding-right: 20px;">
                        New To Aneta?
                        <a 
                          href="https://anetaed.zendesk.com/hc/en-us" 
                          target="_blank" 
                          rel="noreferrer" 
                          style="
                          font-size: 12px; 
                          color: #00B5BA;
                          text-decoration: none;
                          "
                        >
                        Learn more
                      </a>
                        <p style="font-size: 12px; color: #8D869E; margin: 0;">and</p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" width="439">
              <tr>
                <td align="left">
                  <a 
                    href="https://app.anetaed.com/login/" 
                    target="_blank" 
                    rel="noreferrer" 
                    style="
                      width: 162px; 
                      height: 48px; 
                      border-radius: 50px; 
                      background-image: linear-gradient(180deg, #17ECDF 0%, #0B8E86 100%);
                      color: #FFFFFF;
                      display: block;
                      text-align: center;
                      text-decoration: none;
                      font-weight: bold;
                      font-size: 14px;
                      line-height: 48px;
                      font-family: 'Quicksand', sans-serif;
                      "
                  >
                    Login
                  </a>
                </td>
                <td align="right">
                  <a 
                    href="https://app.anetaed.com/choose-role" 
                    target="_blank" 
                    rel="noreferrer" 
                    style="
                      width: 162px; 
                      height: 48px; 
                      border-radius: 50px; 
                      background-image: linear-gradient(360deg, #F5781E 0%, #FFC148 100%);;
                      color: #FFFFFF;
                      display: block;
                      text-align: center;
                      text-decoration: none;
                      font-weight: bold;
                      font-size: 14px;
                      line-height: 48px;
                      font-family: 'Quicksand', sans-serif;
                      "
                  >
                    Sign Up
                  </a>
                </td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: -22px; margin-top: 60px;">
              <tr style="color: #1B0C3D; font-size: 12px; font-weight: bold; font-family: 'Quicksand', sans-serif;">
                <td>Warm regards,</td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" width="100%" height="88" style="border-bottom: 1px solid #E8E7EC;">
              <tr style="color: #1B0C3D; font-size: 25px; font-weight: 700; font-family: 'Quicksand', sans-serif;">
                <td>The Aneta Team</td>
              </tr>
            </table>
            <table cellpadding="0" cellspacing="0" width="100%" style="margin-top: 14px;">
              <tr style="color: #8D869E; font-size: 10px; font-weight: 700; font-family: 'proxima-nova', sans-serif;">
                <td>Anetaed.com, Inc. | <a href="https://anetaed.com" target="_blank" rel="noreferrer" style="color: #00B5BA; text-decoration: none;">https://anetaed.com</a></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
</body>

</html>`;

export default newAnetapackFrom;
